//----------------------
// <auto-generated>
//     Split from WebApiController.ts
//     Regenerate with: node scripts/splitWebApiController.js
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming


import { PosClientBase, PosClientConfig, throwException } from './base';
import type { EventDemandFactor, EventDiscoveryConfigSettings, EventDiscoveryQuotaConfig, EventListingConstraints, EventMarketplaceWebsiteMetrics, EventMetricsTimestamp, EventNotification, EventSectionClearingPrices, EventSectionMetrics, EventSectionMetricsTimePeriod, EventSupplyMetrics, EventSupplyMetricsTimePeriod, EventWebsiteMetricsTimePeriod, InventoryEventDashboardResults, InventoryMetricsQueryId, ListingGroupingMethods, MarketTransaction, OnSaleEventAccess, PosUiActionResult, ScoreModel, SellerAccountEventSetting, SellerEventDashboardMetricsTimePeriod, SellerEventMarketplaceEventInfo, SellerEventNoteResult, Tag, VenueMapInfo } from './types';


export interface IEventConfigClient {

    getVenueMapForEvent(eventId: number | undefined): Promise<VenueMapInfo>;

    getVenueMapsByScoreModelForEvent(eventId: number | undefined): Promise<{ [key in keyof typeof ScoreModel]?: VenueMapInfo; }>;

    getListingConstraintsForEvents(eventIds: number[]): Promise<EventListingConstraints[]>;

    getSellerEventMarketplaceEventInfo(viagogoEventId: number | null | undefined, eventMappingId: string | null | undefined): Promise<SellerEventMarketplaceEventInfo[]>;

    updateSellerEventMarketplaceEventInfos(marketplaceEventInfos: SellerEventMarketplaceEventInfo[]): Promise<boolean>;

    getTagsForEvent(viagogoVirtualId: string | undefined): Promise<Tag[]>;

    getMarketTransactionsForEvent(viagogoEventId: number | undefined, topN: number | undefined): Promise<MarketTransaction[]>;

    updateTagsForEvent(viagogoVirtualId: string | undefined, tags: Tag[]): Promise<boolean>;

    getInternalNotesForEvent(viagogoVirtualId: string | undefined): Promise<string>;

    updateInternalNotesForEvent(viagogoVirtualId: string | undefined, internalNote: string): Promise<boolean>;

    getLastReviewedDateTimeForEvents(viagogoVirtualIds: string[]): Promise<{ [key: string]: string; }>;

    updateLastReviewedDateTimeForEvent(viagogoVirtualId: string | undefined, lastReviewedDateTime: string | undefined): Promise<boolean>;

    getSellerEventNotesByViagogoEventId(viagogoEventId: number | undefined): Promise<SellerEventNoteResult[]>;

    insertSellerEventNotes(viagogoEventId: number | undefined, content: string | undefined): Promise<SellerEventNoteResult>;

    updateSellerEventGroupingMethods(viagogoVirtualId: string | undefined, groupingMethods: ListingGroupingMethods): Promise<boolean>;

    mergeSellerAccountEventSettingsForDelivery(sellerAccountEventSettings: SellerAccountEventSetting[], viagogoEventId: number | undefined): Promise<boolean>;

    getSellerAccountEventSettings(viagogoEventId: number | undefined): Promise<SellerAccountEventSetting[]>;
}

export class EventConfigClient extends PosClientBase implements IEventConfigClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getVenueMapForEvent(eventId: number | undefined, signal?: AbortSignal | undefined): Promise<VenueMapInfo> {
        let url_ = this.baseUrl + "/api/EventConfig/GetVenueMapForEvent?";
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "eventId=" + encodeURIComponent("" + eventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetVenueMapForEvent(_response);
        });
    }

    protected processGetVenueMapForEvent(response: Response): Promise<VenueMapInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VenueMapInfo;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VenueMapInfo>(null as any);
    }

    getVenueMapsByScoreModelForEvent(eventId: number | undefined, signal?: AbortSignal | undefined): Promise<{ [key in keyof typeof ScoreModel]?: VenueMapInfo; }> {
        let url_ = this.baseUrl + "/api/EventConfig/GetVenueMapsByScoreModelForEvent?";
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "eventId=" + encodeURIComponent("" + eventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetVenueMapsByScoreModelForEvent(_response);
        });
    }

    protected processGetVenueMapsByScoreModelForEvent(response: Response): Promise<{ [key in keyof typeof ScoreModel]?: VenueMapInfo; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key in keyof typeof ScoreModel]?: VenueMapInfo; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key in keyof typeof ScoreModel]?: VenueMapInfo; }>(null as any);
    }

    getListingConstraintsForEvents(eventIds: number[], signal?: AbortSignal | undefined): Promise<EventListingConstraints[]> {
        let url_ = this.baseUrl + "/api/EventConfig/GetListingConstraintsForEvents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(eventIds);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListingConstraintsForEvents(_response);
        });
    }

    protected processGetListingConstraintsForEvents(response: Response): Promise<EventListingConstraints[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EventListingConstraints[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EventListingConstraints[]>(null as any);
    }

    getSellerEventMarketplaceEventInfo(viagogoEventId: number | null | undefined, eventMappingId: string | null | undefined, signal?: AbortSignal | undefined): Promise<SellerEventMarketplaceEventInfo[]> {
        let url_ = this.baseUrl + "/api/EventConfig/GetSellerEventMarketplaceEventInfo?";
        if (viagogoEventId !== undefined && viagogoEventId !== null)
            url_ += "viagogoEventId=" + encodeURIComponent("" + viagogoEventId) + "&";
        if (eventMappingId !== undefined && eventMappingId !== null)
            url_ += "eventMappingId=" + encodeURIComponent("" + eventMappingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSellerEventMarketplaceEventInfo(_response);
        });
    }

    protected processGetSellerEventMarketplaceEventInfo(response: Response): Promise<SellerEventMarketplaceEventInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SellerEventMarketplaceEventInfo[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SellerEventMarketplaceEventInfo[]>(null as any);
    }

    updateSellerEventMarketplaceEventInfos(marketplaceEventInfos: SellerEventMarketplaceEventInfo[], signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/EventConfig/UpdateSellerEventMarketplaceEventInfos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(marketplaceEventInfos);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateSellerEventMarketplaceEventInfos(_response);
        });
    }

    protected processUpdateSellerEventMarketplaceEventInfos(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getTagsForEvent(viagogoVirtualId: string | undefined, signal?: AbortSignal | undefined): Promise<Tag[]> {
        let url_ = this.baseUrl + "/api/EventConfig/GetTagsForEvent?";
        if (viagogoVirtualId === null)
            throw new Error("The parameter 'viagogoVirtualId' cannot be null.");
        else if (viagogoVirtualId !== undefined)
            url_ += "viagogoVirtualId=" + encodeURIComponent("" + viagogoVirtualId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTagsForEvent(_response);
        });
    }

    protected processGetTagsForEvent(response: Response): Promise<Tag[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Tag[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Tag[]>(null as any);
    }

    getMarketTransactionsForEvent(viagogoEventId: number | undefined, topN: number | undefined, signal?: AbortSignal | undefined): Promise<MarketTransaction[]> {
        let url_ = this.baseUrl + "/api/EventConfig/GetMarketTransactionsForEvent?";
        if (viagogoEventId === null)
            throw new Error("The parameter 'viagogoEventId' cannot be null.");
        else if (viagogoEventId !== undefined)
            url_ += "viagogoEventId=" + encodeURIComponent("" + viagogoEventId) + "&";
        if (topN === null)
            throw new Error("The parameter 'topN' cannot be null.");
        else if (topN !== undefined)
            url_ += "topN=" + encodeURIComponent("" + topN) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMarketTransactionsForEvent(_response);
        });
    }

    protected processGetMarketTransactionsForEvent(response: Response): Promise<MarketTransaction[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MarketTransaction[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketTransaction[]>(null as any);
    }

    updateTagsForEvent(viagogoVirtualId: string | undefined, tags: Tag[], signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/EventConfig/UpdateTagsForEvent?";
        if (viagogoVirtualId === null)
            throw new Error("The parameter 'viagogoVirtualId' cannot be null.");
        else if (viagogoVirtualId !== undefined)
            url_ += "viagogoVirtualId=" + encodeURIComponent("" + viagogoVirtualId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tags);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateTagsForEvent(_response);
        });
    }

    protected processUpdateTagsForEvent(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getInternalNotesForEvent(viagogoVirtualId: string | undefined, signal?: AbortSignal | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/EventConfig/GetInternalNotesForEvent?";
        if (viagogoVirtualId === null)
            throw new Error("The parameter 'viagogoVirtualId' cannot be null.");
        else if (viagogoVirtualId !== undefined)
            url_ += "viagogoVirtualId=" + encodeURIComponent("" + viagogoVirtualId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInternalNotesForEvent(_response);
        });
    }

    protected processGetInternalNotesForEvent(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    updateInternalNotesForEvent(viagogoVirtualId: string | undefined, internalNote: string, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/EventConfig/UpdateInternalNotesForEvent?";
        if (viagogoVirtualId === null)
            throw new Error("The parameter 'viagogoVirtualId' cannot be null.");
        else if (viagogoVirtualId !== undefined)
            url_ += "viagogoVirtualId=" + encodeURIComponent("" + viagogoVirtualId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(internalNote);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateInternalNotesForEvent(_response);
        });
    }

    protected processUpdateInternalNotesForEvent(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getLastReviewedDateTimeForEvents(viagogoVirtualIds: string[], signal?: AbortSignal | undefined): Promise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/api/EventConfig/GetLastReviewedDateTimeForEvents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viagogoVirtualIds);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLastReviewedDateTimeForEvents(_response);
        });
    }

    protected processGetLastReviewedDateTimeForEvents(response: Response): Promise<{ [key: string]: string; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: string; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: string; }>(null as any);
    }

    updateLastReviewedDateTimeForEvent(viagogoVirtualId: string | undefined, lastReviewedDateTime: string | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/EventConfig/UpdateLastReviewedDateTimeForEvent?";
        if (viagogoVirtualId === null)
            throw new Error("The parameter 'viagogoVirtualId' cannot be null.");
        else if (viagogoVirtualId !== undefined)
            url_ += "viagogoVirtualId=" + encodeURIComponent("" + viagogoVirtualId) + "&";
        if (lastReviewedDateTime === null)
            throw new Error("The parameter 'lastReviewedDateTime' cannot be null.");
        else if (lastReviewedDateTime !== undefined)
            url_ += "lastReviewedDateTime=" + encodeURIComponent("" + lastReviewedDateTime) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateLastReviewedDateTimeForEvent(_response);
        });
    }

    protected processUpdateLastReviewedDateTimeForEvent(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getSellerEventNotesByViagogoEventId(viagogoEventId: number | undefined, signal?: AbortSignal | undefined): Promise<SellerEventNoteResult[]> {
        let url_ = this.baseUrl + "/api/EventConfig/GetSellerEventNotesByViagogoEventId?";
        if (viagogoEventId === null)
            throw new Error("The parameter 'viagogoEventId' cannot be null.");
        else if (viagogoEventId !== undefined)
            url_ += "viagogoEventId=" + encodeURIComponent("" + viagogoEventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSellerEventNotesByViagogoEventId(_response);
        });
    }

    protected processGetSellerEventNotesByViagogoEventId(response: Response): Promise<SellerEventNoteResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SellerEventNoteResult[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SellerEventNoteResult[]>(null as any);
    }

    insertSellerEventNotes(viagogoEventId: number | undefined, content: string | undefined, signal?: AbortSignal | undefined): Promise<SellerEventNoteResult> {
        let url_ = this.baseUrl + "/api/EventConfig/InsertSellerEventNotes?";
        if (viagogoEventId === null)
            throw new Error("The parameter 'viagogoEventId' cannot be null.");
        else if (viagogoEventId !== undefined)
            url_ += "viagogoEventId=" + encodeURIComponent("" + viagogoEventId) + "&";
        if (content === null)
            throw new Error("The parameter 'content' cannot be null.");
        else if (content !== undefined)
            url_ += "content=" + encodeURIComponent("" + content) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInsertSellerEventNotes(_response);
        });
    }

    protected processInsertSellerEventNotes(response: Response): Promise<SellerEventNoteResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SellerEventNoteResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SellerEventNoteResult>(null as any);
    }

    updateSellerEventGroupingMethods(viagogoVirtualId: string | undefined, groupingMethods: ListingGroupingMethods, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/EventConfig/UpdateSellerEventGroupingMethods?";
        if (viagogoVirtualId === null)
            throw new Error("The parameter 'viagogoVirtualId' cannot be null.");
        else if (viagogoVirtualId !== undefined)
            url_ += "viagogoVirtualId=" + encodeURIComponent("" + viagogoVirtualId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(groupingMethods);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateSellerEventGroupingMethods(_response);
        });
    }

    protected processUpdateSellerEventGroupingMethods(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    mergeSellerAccountEventSettingsForDelivery(sellerAccountEventSettings: SellerAccountEventSetting[], viagogoEventId: number | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/EventConfig?";
        if (viagogoEventId === null)
            throw new Error("The parameter 'viagogoEventId' cannot be null.");
        else if (viagogoEventId !== undefined)
            url_ += "viagogoEventId=" + encodeURIComponent("" + viagogoEventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sellerAccountEventSettings);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMergeSellerAccountEventSettingsForDelivery(_response);
        });
    }

    protected processMergeSellerAccountEventSettingsForDelivery(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getSellerAccountEventSettings(viagogoEventId: number | undefined, signal?: AbortSignal | undefined): Promise<SellerAccountEventSetting[]> {
        let url_ = this.baseUrl + "/api/EventConfig/GetSellerAccountEventSettings?";
        if (viagogoEventId === null)
            throw new Error("The parameter 'viagogoEventId' cannot be null.");
        else if (viagogoEventId !== undefined)
            url_ += "viagogoEventId=" + encodeURIComponent("" + viagogoEventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSellerAccountEventSettings(_response);
        });
    }

    protected processGetSellerAccountEventSettings(response: Response): Promise<SellerAccountEventSetting[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SellerAccountEventSetting[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SellerAccountEventSetting[]>(null as any);
    }
}
export interface IEventDiscoveryClient {

    unlockEventDemandData(quotaConfig: EventDiscoveryQuotaConfig): Promise<boolean>;

    tryAccessOnSaleEvent(viagogoEventId: number | undefined): Promise<OnSaleEventAccess>;

    getEventDiscoveryConfigSettings(): Promise<EventDiscoveryConfigSettings>;

    getEventSectionMetrics(eventId: number | undefined, timestamp: EventMetricsTimestamp | undefined): Promise<EventSectionMetrics[]>;

    getEventNotifications(): Promise<EventNotification[]>;

    createEventNotification(input: EventNotification): Promise<EventNotification | null>;

    deleteEventNotification(eventNotifId: string): Promise<PosUiActionResult>;

    updateEventNotification(input: EventNotification): Promise<PosUiActionResult>;
}

export class EventDiscoveryClient extends PosClientBase implements IEventDiscoveryClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    unlockEventDemandData(quotaConfig: EventDiscoveryQuotaConfig, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/EventDiscovery/UnlockEventDemandData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(quotaConfig);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUnlockEventDemandData(_response);
        });
    }

    protected processUnlockEventDemandData(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    tryAccessOnSaleEvent(viagogoEventId: number | undefined, signal?: AbortSignal | undefined): Promise<OnSaleEventAccess> {
        let url_ = this.baseUrl + "/api/EventDiscovery/TryAccessOnSaleEvent?";
        if (viagogoEventId === null)
            throw new Error("The parameter 'viagogoEventId' cannot be null.");
        else if (viagogoEventId !== undefined)
            url_ += "viagogoEventId=" + encodeURIComponent("" + viagogoEventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTryAccessOnSaleEvent(_response);
        });
    }

    protected processTryAccessOnSaleEvent(response: Response): Promise<OnSaleEventAccess> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OnSaleEventAccess;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OnSaleEventAccess>(null as any);
    }

    getEventDiscoveryConfigSettings(signal?: AbortSignal | undefined): Promise<EventDiscoveryConfigSettings> {
        let url_ = this.baseUrl + "/api/EventDiscovery/GetEventDiscoveryConfigSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEventDiscoveryConfigSettings(_response);
        });
    }

    protected processGetEventDiscoveryConfigSettings(response: Response): Promise<EventDiscoveryConfigSettings> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EventDiscoveryConfigSettings;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EventDiscoveryConfigSettings>(null as any);
    }

    getEventSectionMetrics(eventId: number | undefined, timestamp: EventMetricsTimestamp | undefined, signal?: AbortSignal | undefined): Promise<EventSectionMetrics[]> {
        let url_ = this.baseUrl + "/api/EventDiscovery/GetEventSectionMetrics?";
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "eventId=" + encodeURIComponent("" + eventId) + "&";
        if (timestamp === null)
            throw new Error("The parameter 'timestamp' cannot be null.");
        else if (timestamp !== undefined)
            url_ += "timestamp=" + encodeURIComponent("" + timestamp) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEventSectionMetrics(_response);
        });
    }

    protected processGetEventSectionMetrics(response: Response): Promise<EventSectionMetrics[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EventSectionMetrics[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EventSectionMetrics[]>(null as any);
    }

    getEventNotifications(signal?: AbortSignal | undefined): Promise<EventNotification[]> {
        let url_ = this.baseUrl + "/api/EventDiscovery/GetEventNotifications";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEventNotifications(_response);
        });
    }

    protected processGetEventNotifications(response: Response): Promise<EventNotification[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EventNotification[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EventNotification[]>(null as any);
    }

    createEventNotification(input: EventNotification, signal?: AbortSignal | undefined): Promise<EventNotification | null> {
        let url_ = this.baseUrl + "/api/EventDiscovery/CreateEventNotification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateEventNotification(_response);
        });
    }

    protected processCreateEventNotification(response: Response): Promise<EventNotification | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EventNotification;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EventNotification | null>(null as any);
    }

    deleteEventNotification(eventNotifId: string, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/EventDiscovery/DeleteEventNotification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(eventNotifId);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteEventNotification(_response);
        });
    }

    protected processDeleteEventNotification(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    updateEventNotification(input: EventNotification, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/EventDiscovery/UpdateEventNotification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateEventNotification(_response);
        });
    }

    protected processUpdateEventNotification(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }
}
export interface IInventoryEventDashboardClient {

    getEventWebsiteMetrics(queryId: InventoryMetricsQueryId, timePeriod: EventWebsiteMetricsTimePeriod | null | undefined): Promise<EventMarketplaceWebsiteMetrics>;

    getEventDemandFactors(queryId: InventoryMetricsQueryId): Promise<EventDemandFactor[]>;

    getSellerEventDashboardMetrics(queryId: InventoryMetricsQueryId, timePeriod: SellerEventDashboardMetricsTimePeriod | null | undefined): Promise<InventoryEventDashboardResults>;

    getBuyerEventDashboardMetrics(queryId: InventoryMetricsQueryId): Promise<InventoryEventDashboardResults>;

    getEventSectionClearingPrices(queryId: InventoryMetricsQueryId, timePeriod: EventSectionMetricsTimePeriod | null | undefined): Promise<EventSectionClearingPrices[]>;

    getEventSupplyMetrics(queryId: InventoryMetricsQueryId, timePeriod: EventSupplyMetricsTimePeriod | null | undefined): Promise<EventSupplyMetrics[]>;
}

export class InventoryEventDashboardClient extends PosClientBase implements IInventoryEventDashboardClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getEventWebsiteMetrics(queryId: InventoryMetricsQueryId, timePeriod: EventWebsiteMetricsTimePeriod | null | undefined, signal?: AbortSignal | undefined): Promise<EventMarketplaceWebsiteMetrics> {
        let url_ = this.baseUrl + "/api/InventoryEventDashboard/GetEventWebsiteMetrics?";
        if (timePeriod !== undefined && timePeriod !== null)
            url_ += "timePeriod=" + encodeURIComponent("" + timePeriod) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(queryId);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEventWebsiteMetrics(_response);
        });
    }

    protected processGetEventWebsiteMetrics(response: Response): Promise<EventMarketplaceWebsiteMetrics> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EventMarketplaceWebsiteMetrics;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EventMarketplaceWebsiteMetrics>(null as any);
    }

    getEventDemandFactors(queryId: InventoryMetricsQueryId, signal?: AbortSignal | undefined): Promise<EventDemandFactor[]> {
        let url_ = this.baseUrl + "/api/InventoryEventDashboard/GetEventDemandFactors";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(queryId);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEventDemandFactors(_response);
        });
    }

    protected processGetEventDemandFactors(response: Response): Promise<EventDemandFactor[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EventDemandFactor[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EventDemandFactor[]>(null as any);
    }

    getSellerEventDashboardMetrics(queryId: InventoryMetricsQueryId, timePeriod: SellerEventDashboardMetricsTimePeriod | null | undefined, signal?: AbortSignal | undefined): Promise<InventoryEventDashboardResults> {
        let url_ = this.baseUrl + "/api/InventoryEventDashboard/GetSellerEventDashboardMetrics?";
        if (timePeriod !== undefined && timePeriod !== null)
            url_ += "timePeriod=" + encodeURIComponent("" + timePeriod) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(queryId);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSellerEventDashboardMetrics(_response);
        });
    }

    protected processGetSellerEventDashboardMetrics(response: Response): Promise<InventoryEventDashboardResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InventoryEventDashboardResults;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InventoryEventDashboardResults>(null as any);
    }

    getBuyerEventDashboardMetrics(queryId: InventoryMetricsQueryId, signal?: AbortSignal | undefined): Promise<InventoryEventDashboardResults> {
        let url_ = this.baseUrl + "/api/InventoryEventDashboard/GetBuyerEventDashboardMetrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(queryId);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBuyerEventDashboardMetrics(_response);
        });
    }

    protected processGetBuyerEventDashboardMetrics(response: Response): Promise<InventoryEventDashboardResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InventoryEventDashboardResults;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InventoryEventDashboardResults>(null as any);
    }

    getEventSectionClearingPrices(queryId: InventoryMetricsQueryId, timePeriod: EventSectionMetricsTimePeriod | null | undefined, signal?: AbortSignal | undefined): Promise<EventSectionClearingPrices[]> {
        let url_ = this.baseUrl + "/api/InventoryEventDashboard/GetEventSectionClearingPrices?";
        if (timePeriod !== undefined && timePeriod !== null)
            url_ += "timePeriod=" + encodeURIComponent("" + timePeriod) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(queryId);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEventSectionClearingPrices(_response);
        });
    }

    protected processGetEventSectionClearingPrices(response: Response): Promise<EventSectionClearingPrices[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EventSectionClearingPrices[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EventSectionClearingPrices[]>(null as any);
    }

    getEventSupplyMetrics(queryId: InventoryMetricsQueryId, timePeriod: EventSupplyMetricsTimePeriod | null | undefined, signal?: AbortSignal | undefined): Promise<EventSupplyMetrics[]> {
        let url_ = this.baseUrl + "/api/InventoryEventDashboard/GetEventSupplyMetrics?";
        if (timePeriod !== undefined && timePeriod !== null)
            url_ += "timePeriod=" + encodeURIComponent("" + timePeriod) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(queryId);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEventSupplyMetrics(_response);
        });
    }

    protected processGetEventSupplyMetrics(response: Response): Promise<EventSupplyMetrics[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EventSupplyMetrics[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EventSupplyMetrics[]>(null as any);
    }
}
